const MetaTrader5ContentFour = () => {
  return (
    <div className="how__work__platform">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="thumb-left">
              <div className="content-left">
                <h2>What You Can Trade on MetaTrader 5</h2>

                <p>
                  Expand your opportunities with access to a full suite of
                  global markets, all from your MT5 terminal.
                </p>
              </div>
              <img
                src={process.env.PUBLIC_URL + "/images/platforms/meta_trader_4/meta_trader_4_03.png"}
                alt="computer images"
              />
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="content-right">
              <h3>Forex</h3>
              <p>
                Trade major, minor, and exotic pairs with ultra-tight spreads
                and instant execution. MT5’s optimized performance ensures you
                capture every market move.
                {/* Conversely, rate cuts can weaken a
                currency as investors seek higher yields elsewhere. Traders
                closely follow central bank announcements and policy statements
                to anticipate shifts in monetary policy. */}
              </p>
              <hr className="black-line" />
              <h3> Stocks</h3>
              <p>
                Access leading global companies and build your equity portfolio
                directly from MT5. Analyze charts, monitor real-time
                performance, and trade confidently with transparent pricing.
                {/* Stable inflation and strong
                performance usually strengthen a currency, while economic
                slowdown or uncertainty can cause depreciation. Traders monitor
                key indicators like CPI, PMI, and retail sales to identify
                potential trends in currency valuation. */}
              </p>
              <hr className="black-line" />
              <h3>Commodities</h3>
              <p>
                Trade gold, silver, oil, and other essential commodities. With
                MT5, you get accurate price feeds and flexible leverage options
                for stable portfolio diversification.
                {/* In contrast, geopolitical
                tensions or unexpected global events can increase volatility as
                traders move toward safe-haven assets like the USD, CHF, or JPY. */}
              </p>
              <hr className="black-line" />
              <h3>Cryptocurrencies</h3>
              <p>
                Stay ahead of the digital revolution. Trade major crypto assets
                like Bitcoin, Ethereum, and more with real-time data and fast
                execution from The Pips’ MT5 servers.
                {/* Large institutional players and algorithmic trading
                systems can amplify these effects, making sentiment analysis a
                valuable tool for modern forex traders. */}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MetaTrader5ContentFour;
